import { render } from "./workExperienceComponent.vue?vue&type=template&id=2ba44e81&scoped=true"
const script = {}

import "./workExperienceComponent.vue?vue&type=style&index=0&id=2ba44e81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba44e81"]])

export default __exports__